import {createSelector} from 'reselect'
import {AnyAction, Dispatch} from '@modifi/redux'

import {differenceWith, eqProps} from 'ramda'
import {aFetchDocumentsByExternalPersonId} from '../../../../data/person-documents'
import {rootSelector} from '../../../../redux/root-selector'
import {selectDirectors} from '../../../../data/directors'
import {selectBeneficialOwners} from '../../../../data/beneficial-owners'
import {selectLegalRepresentatives} from '../../../../data/legal-representatives'

const ACTION_SELECT_DATA_SOURCE_PERSON = 'pages/directors/SELECT_DATA_SOURCE_PERSON'
const ACTION_CLEAR_DATA_SOURCE_PERSON = 'pages/directors/CLEAR_DATA_SOURCE_PERSON'

type DataSourceState = {
  dataSourceExternalPersonId: string | null
}

const initialState: DataSourceState = {
  dataSourceExternalPersonId: null,
}

export default (state = initialState, {type, payload}: AnyAction): DataSourceState => {
  switch (type) {
    case ACTION_SELECT_DATA_SOURCE_PERSON: {
      const {externalPersonId} = payload
      return {
        ...state,
        dataSourceExternalPersonId: externalPersonId,
      }
    }
    case ACTION_CLEAR_DATA_SOURCE_PERSON:
      return {
        ...state,
        dataSourceExternalPersonId: null,
      }
    default:
      return state
  }
}

const baseSelector = createSelector(rootSelector, root => root?.pages?.directors?.dataSource)

export const selectDataSourcePerson = createSelector(
  baseSelector,
  subState => subState.dataSourceExternalPersonId
)

export const selectAvailableDataSourceOptions = createSelector(
  selectBeneficialOwners,
  selectLegalRepresentatives,
  selectDirectors,
  (beneficialOwners, legalRepresentatives, directors) =>
    differenceWith(
      eqProps('externalId'),
      beneficialOwners.concat(legalRepresentatives),
      directors
    )?.map(({firstName, middleName, lastName, externalId}) => ({
      label: `${firstName} ${middleName ? `${middleName} ` : ''}${lastName}`,
      value: externalId,
    }))
)

export const aSelectPersonAsDataSource =
  (externalPersonId: string) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: ACTION_SELECT_DATA_SOURCE_PERSON,
      payload: {externalPersonId},
    })

    if (externalPersonId) {
      dispatch(aFetchDocumentsByExternalPersonId(externalPersonId))
    }
  }

export const aClearDataSourcePerson = (): AnyAction => ({
  type: ACTION_CLEAR_DATA_SOURCE_PERSON,
})
